module.exports = __webpack_public_path__ + "static/img/PU_Img2.4d9ffb3d.jpg";